<!--
  BottomNav.vue
-->

<!-- -------------------------------------------------------------------------------- -->
<!-- template -->
<template>
  <div class="hm-display-mobile">

  <v-bottom-nav :value="mVisible" :active="mCurrentPage" app fixed>
    <v-btn flat color="primary" value="map" @click="onClickMap">
      <span>{{ $t("bottomnav.gnss") }}</span>
      <v-icon>place</v-icon>
    </v-btn>
    <v-btn flat color="primary" value="member" @click="onClickMember">
      <span>{{ $t("bottomnav.oneself") }}</span>
      <v-icon>person</v-icon>
    </v-btn>
    <v-btn flat color="primary" value="group" @click="onClickGroup">
      <span>{{ $t("bottomnav.groups") }}</span>
      <v-icon>group</v-icon>
    </v-btn>
  </v-bottom-nav>

  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import { ROUTE_NAME, ROUTE_PATH } from '@/router/routes'

export default {
  name: 'BottomNav',
  data: () => ({
    mVisible: true,
  }),
  mounted: function () {
    this.$log.debug('# BottomNav mounted.')
  },
  destroyed: function () {
    this.$log.debug('# BottomNav destoroyed.')
  },
  computed: {
    ...mapState({
      mCurrentPage: state => state.currentPage.sCurrentPage,
      mIsEdit: state => state.sIsEdit,
    }),
  },
  watch: {
    mIsEdit: function (current, previous) {
      // Mobileで編集しているとき(キーパッドが表示されているとき)は、BottomBarを非表示にする
      this.mVisible = !current
    }
  },
  methods: {
    // -------------------------------------------------------------------------
    onClickMap: function () {
      this.$router.push(ROUTE_PATH.ROUTE_MAP_LOCATION)
      this.$store.dispatch('aChangeCurrentPage', 'map')
    },
    // -------------------------------------------------------------------------
    // ログインユーザの行先情報を表示する
    onClickMember: function () {
      this.$router.push({
        name: ROUTE_NAME.ROUTE_WHEREABOUTS_INFO,
        params: { id: this.$store.getters.loginUserId }
      })
      this.$store.dispatch('aChangeCurrentPage', 'member')
    },
    // -------------------------------------------------------------------------
    onClickGroup: function () {
      this.$router.push(ROUTE_PATH.ROUTE_WHEREABOUTS_LIST)
      this.$store.dispatch('aChangeCurrentPage', 'group')
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BottomNav.vue